import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { Follow } from '../../molecules/follow';
import type { Props as ComponentProps } from './types';
import type { CompanyData } from '../../../types/companies';

type Props = ComponentProps & {
  loading: boolean;
  companyData: CompanyData;
  renderCountItem: (count: number, label: string, link: string, value: string) => JSX.Element;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  const logoUrl = props.companyData.logo_url || props.noCompanyIcon;

  return (
    <div className="new-company-index">
      <article className="new-company-index__card-container">
        <div className="new-company-index__card-inner">
          <div className={classnames('new-company-index__card', { 'new-company-index__card--no-counts': props.showCounts === false })}>
            <div className="new-company-index__card-author">
              <div className="new-company-index__card-author__logo">
                <img
                  src={logoUrl}
                  alt={`${props.companyData.name}のロゴ`}
                  className="new-company-index__card-author__logo-img"
                />
              </div>
              <div className="new-company-index__card-author__info">
                <a
                  href={`/companies/${props.companyData.id}`}
                  className="new-company-index__card-link gtm-link-view-count"
                  data-event-name='link on screen'
                  data-event="click"
                  data-category={props.dataCategory}
                  data-value={props.dataValue.companyName}
                >
                  {props.companyData.name}
                </a>
                {props.companyData.industries && props.companyData.industries.length > 0 && (
                  <div className="new-company-index__card-author__industry gtm-link-view-count" data-event-name='link on screen' data-category={props.dataCategory} data-value={props.dataValue.industryLink}>
                    {props.companyData.industries.length > 0 && (
                      <svg
                        className="new-company-index__card-author__industry-icon"
                        width="18"
                        viewBox="0 0 18 18"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.84625 16.1663C2.46264 16.1663 2.14236 16.0379 1.88542 15.7809C1.62847 15.524 1.5 15.2037 1.5 14.8201V6.67926C1.5 6.29565 1.62847 5.97537 1.88542 5.71842C2.14236 5.46148 2.46264 5.33301 2.84625 5.33301H6.5V4.17905C6.5 3.79558 6.62847 3.47537 6.88542 3.21842C7.14236 2.96148 7.46264 2.83301 7.84625 2.83301H10.1538C10.5374 2.83301 10.8576 2.96148 11.1146 3.21842C11.3715 3.47537 11.5 3.79558 11.5 4.17905V5.33301H15.1538C15.5374 5.33301 15.8576 5.46148 16.1146 5.71842C16.3715 5.97537 16.5 6.29565 16.5 6.67926V14.8201C16.5 15.2037 16.3715 15.524 16.1146 15.7809C15.8576 16.0379 15.5374 16.1663 15.1538 16.1663H2.84625ZM2.84625 15.333H15.1538C15.2821 15.333 15.3997 15.2796 15.5065 15.1728C15.6133 15.066 15.6667 14.9484 15.6667 14.8201V6.67926C15.6667 6.55092 15.6133 6.43335 15.5065 6.32655C15.3997 6.21974 15.2821 6.16634 15.1538 6.16634H2.84625C2.71792 6.16634 2.60035 6.21974 2.49354 6.32655C2.38674 6.43335 2.33333 6.55092 2.33333 6.67926V14.8201C2.33333 14.9484 2.38674 15.066 2.49354 15.1728C2.60035 15.2796 2.71792 15.333 2.84625 15.333ZM7.33333 5.33301H10.6667V4.17905C10.6667 4.05085 10.6133 3.93335 10.5065 3.82655C10.3997 3.71974 10.2821 3.66634 10.1538 3.66634H7.84625C7.71792 3.66634 7.60035 3.71974 7.49354 3.82655C7.38674 3.93335 7.33333 4.05085 7.33333 4.17905V5.33301Z"
                          fill="#808080"
                        />
                      </svg>
                    )}
                    {props.companyData.industries.map((industry, index) => (
                      <React.Fragment key={industry.id}>
                        {' '}
                        {/* key を industry.id に変更 */}
                        {index > 0 && <span className="new-company-index__card-author__industry-separator">,</span>}
                        <a
                          href={`/companies/tag/${industry.enName}`}
                          className="new-company-index__card-author__industry-item"
                          data-event="click"
                          data-category={props.dataCategory}
                          data-value={props.dataValue.industryLink}
                        >
                          {industry.jpName}
                        </a>
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          {props.companyData.description && (
            <div className="new-company-index__card-body">
              <p className="new-company-index__card-body__text">{props.companyData.description}</p>
            </div>
          )}
          <div className={classnames('new-company-index__card__footer', { 'new-company-index__card__footer--no-counts': props.showCounts === false })}>
            {props.showCounts !== false && (
              <div className="new-company-index__card__detail">
                {props.renderCountItem(
                  props.companyData.recruitment_count,
                  '募集中求人',
                  `/companies/${props.companyData.id}/recruitments`,
                  'recruitment'
                )}
                {props.renderCountItem(
                  props.companyData.event_count,
                  'イベント',
                  `/companies/${props.companyData.id}/events`,
                  'event'
                )}
                {props.renderCountItem(
                  props.companyData.story_count,
                  'ストーリー',
                  `/companies/${props.companyData.id}/stories`,
                  'story'
                )}
              </div>
            )}
            <Follow
              company_id={props.companyId}
              user={props.user}
              page="companyIndex"
              lineIcon={props.lineIcon}
            />
          </div>
        </div>
      </article>
    </div>
  );
};
